/* template */
<template><mpx-view :class='((externClass)+" "+(show ? "show" : "hide"))' :style="[(externStyle)] | transRpxStyle" @tap="close" class="mask"></mpx-view></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m778d9a52"}'>
.mask
  position fixed
  top 0
  bottom 0
  left 0
  right 0
  background rgb(0, 0, 0)
  z-index 650
  opacity 0
  transition-timing-function linear
  transition-duration 300ms
  transition-property opacity, visibility
  touch-action none
.show
  opacity 0.7
  visibility visible
.hide
  opacity 0
  visibility hidden
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m778d9a52"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex778d9a52%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex778d9a52%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m778d9a52"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index778d9a52/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
